import React, { useMemo } from 'react';
import { NextPage } from 'next';
import { useSelector } from 'react-redux';
import { Typography } from '@material-ui/core';
import MetaLayout from '€layouts/MetaLayout';
import PreAuthLayout from '€layouts/PreAuthLayout';
import LoginForm from '€components/LoginForm';
import { getResetPasswordSuccess } from '€slices/password-reset/password-reset-selectors';
import Message, { MessageStatus } from '€components/Message';
import { loginFailed } from '€slices/auth';
import { timedOut } from '€slices/network';

const Login: NextPage = () => {
    const resetPasswordSuccess = useSelector(getResetPasswordSuccess);
    const loginError = useSelector(loginFailed);
    const sessionTimeOut = useSelector(timedOut);

    const flashMessage = useMemo(() => {
        let node: React.ReactNode;

        if (resetPasswordSuccess) {
            node = (
                <Message
                    style={{
                        backgroundColor: 'rgb(168,74,224,0.1)',
                        borderRadius: '2.5rem',
                    }}
                >
                    <Typography variant="subtitle2" color="primary">
                        Your password has been updated successfully.
                    </Typography>
                </Message>
            );
        }

        if (loginError) {
            node = (
                <Message
                    style={{
                        borderRadius: '2.5rem',
                    }}
                    status={MessageStatus.Error}
                >
                    <Typography variant="subtitle2">
                        It looks like the email/username or password you entered isn’t right.
                    </Typography>
                </Message>
            );
        }

        if (sessionTimeOut) {
            node = (
                <Message
                    style={{
                        borderRadius: '2.5rem',
                    }}
                    status={MessageStatus.Error}
                >
                    <Typography variant="subtitle2">
                        Your session has timed out. Please log in again.
                    </Typography>
                </Message>
            );
        }

        return node;
    }, [loginError, resetPasswordSuccess, sessionTimeOut]);

    return (
        <MetaLayout metaTitle="Loan | Login">
            <PreAuthLayout
                title="Partner portal"
                subtitle="Log in to track the progress of your customer’s applications with us."
                flashMessage={flashMessage}
            >
                <LoginForm />
            </PreAuthLayout>
        </MetaLayout>
    );
};

export default Login;
